<template>
  <tr-dialog
    ref="modalRef"
    :hide-cancel-button="true"
    name="blocked-user-error-dialog"
    title="Sua conta requer atenção"
  >
    <bg-stack space="sm">
      <card-info
        color="yellow"
        icon="alert-outline"
      >
        <bg-text type="body-md">
          Olá! Para manter a regularidade e a segurança de suas operações, algumas funcionalidades
          da sua conta foram suspensas.
          <b> Seu acesso para visualização e consulta de dados continua ativo.</b>
        </bg-text>
      </card-info>
      <bg-text type="body-md">
        Os seguintes bloqueios foram realizados:
      </bg-text>
      <ul :class="$style.list">
        <li
          v-for="permission in blockedPermissions"
          :key="permission.name"
        >
          {{ permission.description }}
        </li>
      </ul>
    </bg-stack>
    <template #buttons>
      <div
        class="is-flex flex-end"
        style="gap: 16px"
      >
        <bg-button
          variant="outline"
          @click="goToSupport"
        >
          Falar com o suporte
        </bg-button>
        <bg-button
          variant="solid"
          @click="confirm"
        >
          Entendi
        </bg-button>
      </div>
    </template>
  </tr-dialog>
</template>

<script setup>
import { computed, ref } from 'vue';
import { BgButton, BgText, BgStack } from '@transfeeradev/bridge';
import CardInfo from '@/commons/components/presentational/CardInfo.vue';
import loggedUserResource from '@/commons/resources/loggedUser';
import permissions from '@/commons/constants/permissions';

const modalRef = ref(null);
const userPermissions = ref(loggedUserResource.getPermissions());

const emit = defineEmits(['onCancel']);

const blockedPermissions = computed(() => {
  if (!userPermissions.value?.length) {
    return Object.values(permissions);
  }

  if (userPermissions.value.includes('all')) {
    return [];
  }

  return Object.keys(permissions)
    .filter(permissionKey => !userPermissions.value?.includes(permissionKey))
    .map(permissionKey => permissions[permissionKey]);
});

const openIfHasBlock = () => {
  if (userPermissions.value?.includes('all')) {
    return;
  }

  modalRef.value.open();
};

const goToSupport = () => {
  if (window.Huggy) {
    window.Huggy.openBox();
  }

  close();
};

const close = () => {
  modalRef.value.close();
  emit('onCancel');
};

const confirm = () => {
  close();
};

defineExpose({
  openIfHasBlock
});
</script>

<style module scoped>
.table {
  border: 1px solid var(--bg-grey-light);
  border-radius: var(--bg-border-radius-md);
  border-collapse: separate;
  margin-bottom: 0;
}

.list {
  display: grid;
  gap: 8px;
}
</style>
